function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import CollapseButton from './CollapseButton';
import MoreButton from './MoreButton';
import HelpLink from './HelpLink';

var HelpComponents = function HelpComponents() {
  _classCallCheck(this, HelpComponents);
};

HelpComponents.CollapseButton = CollapseButton;
HelpComponents.MoreButton = MoreButton;
HelpComponents.HelpLink = HelpLink;
export default HelpComponents;
//# sourceMappingURL=index.js.map
